const StopOnFailureFieldsetDescription = () =>
  <>
    Test config continues to run even if a step fails, and it continues running until all steps, including reruns, are completed.
  </>

export default StopOnFailureFieldsetDescription
